import React, { useEffect, useState } from "react";
import Header from "../directives/header";
import Sidebar from "../directives/sidebar";
import Footer from "../directives/footer";
import config from "../coreFIles/config";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
  getSiteIndustriesAction,
  createSiteIndustryAction,
  updateSiteIndustryAction,
  deleteSiteIndustryAction,
  SiteIndustryBlockUnBlockAction,
} from "../Action/action";

const emptyForm = {
  id: "",
  title: "",
  description: "",
  thumbnail: "",
  thumbnail_url: "",
  sort_order: "0",
  is_active: "1",
};

const Industries = () => {
  const loginData = !Cookies.get("loginSuccessfastenerwarehouseAdmin")
    ? []
    : JSON.parse(Cookies.get("loginSuccessfastenerwarehouseAdmin"));
  if (!loginData || loginData === "") {
    window.location.href = `${config.baseUrl}`;
  }
  if (loginData.role != config.role_admin) {
    window.location.href = `dashboard`;
  }

  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [spinloader, setspinloader] = useState(1);
  const [saving, setSaving] = useState(0);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const res = await getSiteIndustriesAction({});
    if (res.success) {
      setList(res.data || []);
    } else {
      setList([]);
    }
    setspinloader(0);
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setForm((old) => ({ ...old, [name]: value }));
  };

  const fileHandler = (e) => {
    setForm((old) => ({ ...old, thumbnail: e.target.files?.[0] || "" }));
  };

  const resetForm = () => {
    setForm(emptyForm);
    const input = document.getElementById("industry_thumbnail");
    if (input) input.value = "";
  };

  const editRow = (item) => {
    setForm({
      id: item.id,
      title: item.title || "",
      description: item.description || "",
      thumbnail: "",
      thumbnail_url: item.thumbnail || "",
      sort_order: String(item.sort_order ?? 0),
      is_active: String(item.is_active ?? 1),
    });
    const input = document.getElementById("industry_thumbnail");
    if (input) input.value = "";
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const saveRow = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error("Title is required.");
      return;
    }
    setSaving(1);
    const payload = {
      title: form.title.trim(),
      description: form.description,
      sort_order: form.sort_order || 0,
      is_active: form.is_active,
    };
    if (form.id) payload.id = form.id;
    if (form.thumbnail) payload.thumbnail = form.thumbnail;
    const res = form.id ? await updateSiteIndustryAction(payload) : await createSiteIndustryAction(payload);
    setSaving(0);
    if (res.success) {
      toast.success(res.msg);
      resetForm();
      getList();
    } else {
      toast.error(res.msg || "Something went wrong.");
    }
  };

  const deleteRow = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this industry!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await deleteSiteIndustryAction({ id });
      if (res.success) {
        toast.success(res.msg);
        if (String(form.id) === String(id)) resetForm();
        getList();
      } else {
        toast.error(res.msg);
      }
    });
  };

  const handleStatus = async (id, is_active) => {
    Swal.fire({
      title: "Are you sure?",
      text:
        is_active === 0
          ? "Are you sure you want to hide this industry on the website?"
          : "Are you sure you want to show this industry on the website?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: is_active == 0 ? "Yes, Hide it!" : "Yes, Show it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const res = await SiteIndustryBlockUnBlockAction({ id, is_active });
      if (res.success) {
        getList();
        toast.success(is_active == 0 ? "Industry hidden successfully!" : "Industry published successfully!");
      } else {
        toast.error(res.msg);
      }
    });
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Toaster />
        <Header />
        <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
                <span>
                  <a className="homelink" href={`${config.baseUrl}dashboard`}>
                    Home
                  </a>
                </span>
              </li>
              <li className="breadcrumb-item active">
                <span>Industries</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="card mb-4">
                  <div className="card-header">
                    <span>{form.id ? "Edit Industry" : "Add Industry"}</span>
                  </div>
                  <div className="card-body inner-body">
                    <form className="row g-3" onSubmit={saveRow}>
                      <div className="col-md-12">
                        <label className="form-label" htmlFor="title">
                          Title
                        </label>
                        <input
                          className="form-control"
                          id="title"
                          name="title"
                          type="text"
                          placeholder="Enter title"
                          value={form.title}
                          onChange={inputHandler}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" htmlFor="industry_thumbnail">
                          Thumbnail image {form.id ? "(leave blank to keep current)" : ""}
                        </label>
                        <input
                          className="form-control"
                          id="industry_thumbnail"
                          name="thumbnail"
                          type="file"
                          accept="image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif"
                          onChange={fileHandler}
                        />
                        {form.thumbnail_url ? (
                          <a
                            className="d-inline-block mt-2"
                            href={`${config.imageUrl}/${form.thumbnail_url}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={`${config.imageUrl}/${form.thumbnail_url}`}
                              alt=""
                              style={{ maxWidth: 96, maxHeight: 96, objectFit: "cover" }}
                            />
                          </a>
                        ) : null}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label" htmlFor="is_active">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="is_active"
                          name="is_active"
                          value={form.is_active}
                          onChange={inputHandler}
                        >
                          <option value="1">Active</option>
                          <option value="0">Hidden</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label" htmlFor="sort_order">
                          Sort order
                        </label>
                        <input
                          className="form-control"
                          id="sort_order"
                          name="sort_order"
                          type="number"
                          value={form.sort_order}
                          onChange={inputHandler}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="form-label" htmlFor="description">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="description"
                          name="description"
                          rows="10"
                          placeholder="Enter description"
                          value={form.description}
                          onChange={inputHandler}
                          style={{ minHeight: 180 }}
                        />
                      </div>
                      <div className="col-12 text-end">
                        {form.id ? (
                          <button type="button" className="btn btn-secondary me-2" onClick={resetForm}>
                            Cancel
                          </button>
                        ) : null}
                        <button className="btn btn-primary" type="submit" disabled={saving === 1}>
                          {saving === 1 ? "Processing..." : form.id ? "Update" : "Add Industry"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-header">
                    <span>Industries</span>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0">
                        <thead className="table-light fw-semibold">
                          <tr className="align-middle table-heading">
                            <th>Sr.</th>
                            <th>Thumb</th>
                            <th>Title</th>
                            <th>Sort</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spinloader == 0 ? (
                            list.length > 0 ? (
                              list.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {item.thumbnail ? (
                                      <img
                                        src={`${config.imageUrl}/${item.thumbnail}`}
                                        alt=""
                                        style={{ width: 48, height: 48, objectFit: "cover" }}
                                      />
                                    ) : (
                                      "—"
                                    )}
                                  </td>
                                  <td>{item.title}</td>
                                  <td>{item.sort_order}</td>
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.is_active === 1}
                                        onChange={() => handleStatus(item.id, item.is_active === 1 ? 0 : 1)}
                                      />
                                    </div>
                                  </td>
                                  <td className="td-action">
                                    <button type="button" className="btn btn-primary editbtn" onClick={() => editRow(item)}>
                                      <i className="far fa-edit"></i> Edit
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                      type="button"
                                      className="btn btn-primary deletebtn"
                                      onClick={() => deleteRow(item.id)}
                                    >
                                      <i className="fa fa-trash"></i> Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No industries found.
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                <img
                                  className="loaderImg search-loader"
                                  src={config.baseUrl + "images/loader.gif"}
                                  height={20}
                                  width={20}
                                  alt=""
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Industries;
